<template>
    <div class="chat-box-available" v-if="count" @click="$emit('selectAvailable')">
        <span>{{ $t('common.available groups') }}</span>
        <div class="chat-box-available__amount">
            <span>{{ count }}</span>
            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.27445 0.5L0.00012963 1.73157L5.44968 6.99999L0 12.2684L1.27432 13.5L8 6.99994L1.27445 0.5Z" fill="#ACACAC"/>
            </svg>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default Vue.extend({
        name: "ChatBoxAvailableCount",
        props: {
            count: {
                type: [Number, undefined],
                default: undefined
            }
        }
    });
</script>